import { useCombinedPermissions } from '@auth/hooks/useCombinedPermissions'
import EnhancedNavTabs from '@common/components/Tab/EnhancedNavTabs'
import { tabItems, reader_excluded_tabs, study_overview_excluded_role } from '@common/constants/tabs'
import useUserProfile from '@features/user_management/hooks/useUserProfile'
import { useParams } from 'react-router-dom'

export default function StudyDetailsTabs() {
  const { studyId } = useParams<{ studyId: string }>()
  const { hasAnyPermission } = useCombinedPermissions()
  const { data: userProfile } = useUserProfile()
  const isUserReader = study_overview_excluded_role.includes(userProfile?.role?.name || '')
  const filteredTabRoutes = tabItems
    .filter(
      (item) =>
        ((!item.permissions || hasAnyPermission(item.permissions)) && !isUserReader) ||
        (isUserReader &&
          !reader_excluded_tabs.includes(item.route) &&
          (!item.permissions || hasAnyPermission(item.permissions))),
    )
    .map((item) => ({
      ...item.route,
      path: item.route.path.replace(':studyId', studyId!),
    }))

  return <EnhancedNavTabs routes={filteredTabRoutes} />
}
